import {
    createSlice,
    type PayloadAction
} from '@reduxjs/toolkit';

interface ApplicationState {
    isConnected: boolean
    isReady: boolean
    timezone: string
}

export const initialState:ApplicationState = {
    isConnected: false,
    isReady: false,
    timezone: localStorage.getItem('gardener_timezone') || 'Asia/Seoul'
}

const applicationSlice = createSlice({
    name: 'application',
    initialState,
    reducers: {
        setIsConnected: (state, action: PayloadAction<boolean>) => {
            state.isConnected = action.payload
        },
        ready: (state) => {
            state.isReady = true
        },
        setTimezone: (state, action: PayloadAction<string>) => {
            state.timezone = action.payload
            localStorage.setItem('gardener_timezone', action.payload)
        }
    }
})

export const {
    setIsConnected,
    ready,
    setTimezone
} = applicationSlice.actions;
export default applicationSlice.reducer